import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-fahrzeugverwendungsbestimmung-list-view',
  imports: [],
  templateUrl: './fahrzeugverwendungsbestimmung.list-view.html',
  styleUrls: ['./fahrzeugverwendungsbestimmung.list-view.css'],
})
export class FahrzeugverwendungsbestimmungListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
